import React from "react";
import "./styles/therapy.css";
import TakingNotes from "../../assets/taking-notes.jpg";
import Sunrise from "../../assets/sunrise.mp4";
import ServiceWarning from "../../components/ServiceWarning";

const PsychodiagnosticAssessments = () => {
  return (
    <section className="therapy-section">
      <div className="therapy-card">
        <div className="video-banner">
          <video className="therapy-video" autoPlay muted loop playsInline>
            <source src={Sunrise} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="therapy-content">
          <h1>Psychodiagnostic Assessments</h1>
          <p>
            Psychodiagnostic assessments are a valuable tool for gaining clarity
            about emotional, cognitive, and behavioural functioning. This
            process can help answer long-standing questions, provide diagnostic
            clarity, and guide treatment planning. Whether you are seeking
            greater self-understanding, looking to inform a therapeutic
            approach, or needing documentation for professional or medical
            purposes, a psychological assessment can offer meaningful insight
            and direction.
          </p>
          <p>
            My assessment process is comprehensive and evidence-based. It
            typically includes structured clinical interviews, standardized
            outcome measures and a review of relevant documentation. The
            findings are compiled into an 8 to 11 page report, which includes
            diagnostic formulations, differential diagnoses, clinical
            conceptualizations, and individualized recommendations. A one-page
            attestation letter summarizing the diagnostic conclusion is provided
            when appropriate.
          </p>
          <p>
            All assessments conclude with a detailed feedback session, during
            which I walk you through the results and the clinical reasoning that
            informed the conclusions, helping you make sense of both the
            findings and the process that led us there. This collaborative
            conversation ensures the process is both informative and empowering.
          </p>
          <h2>Fee:</h2>
          <p>
            The total fee for psychodiagnostic assessment service is $2,210.
            This cost includes:
          </p>
          <ul className="styled-list">
            <li>Submission and review of online measures</li>

            <li>3 hours of diagnostic interviews</li>
            <li>Scoring of online-, self-reported- and collateral measures</li>
            <li>
              A comprehensive report of approximately 8-10 pages, and a letter
              of attestation containing a one-page summary of the assessment
            </li>
            <li>
              A feedback session to review the results and treatment
              recommendations
            </li>
          </ul>
        </div>

        <div className="bottom-image-wrapper">
          <img
            src={TakingNotes}
            alt="Therapy session representation"
            className="therapy-image"
          />
        </div>
      </div>
      <ServiceWarning />
    </section>
  );
};

export default PsychodiagnosticAssessments;
